module.exports = __webpack_public_path__ + "static/img/pro4.9a63157e.jpg";